import React, { useState, useEffect } from "react";
import Button from "../Buttons";

const QRViewer = ({ data }) => {
  const [qrCodes, setQrCodes] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let qrList = [];

    if (data?.qr) {
      qrList = [data.qr];
    } else if (Array.isArray(data?.items)) {
      data.items.forEach((item) => {
        if (Array.isArray(item.qr)) {
          item.qr.forEach((q) => {
            if (q?.qr) qrList.push(q.qr);
          });
        }
      });
    }

    setQrCodes(qrList);
    setCurrentIndex(0);
  }, [data]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < qrCodes.length - 1 ? prev + 1 : prev));
  };

  if (qrCodes.length === 0) {
    return <div>No QR codes found.</div>;
  }

   const handleDownload = () => {
    qrCodes.forEach((base64Image, index) => {
      const link = document.createElement("a");
      link.href = base64Image;
      link.download = `qr-code-${index + 1}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "2rem",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "200px", height: "200px", margin: "1rem auto" }}>
        <img
          style={{ width: "200px", height: "200px" }}
          src={qrCodes[currentIndex]}
          alt={`QR Code ${currentIndex + 1}`}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          width="120px"
          variant="filled"
          onClick={handlePrev}
          disabled={currentIndex === 0}
          label={"Previous"}
        />

        <span style={{ margin: "0 1rem" }}>
          {currentIndex + 1} / {qrCodes.length}
        </span>
        <Button
          width="120px"
          variant="filled"
          label={"Next"}
          onClick={handleNext}
          disabled={currentIndex === qrCodes.length - 1}
        />
      </div>
      <div style={{ marginTop: "1rem" }}>
        <Button
          width="150px"
          variant="filled"
          label={"Download QRs"}
          onClick={handleDownload}
        />
      </div>
    </div>
  );
};

export default QRViewer;
